import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "InboxRule" */ './lazyIndex');
});
export var lazyShowInboxRuleDialog = new LazyAction(lazyModule, function (m) { return m.showInboxRuleDialog; });
//# sourceMappingURL=index.js.map